import { Button, Form } from "antd";
import { RegisterationText } from "texts/registerationText";
import { PlusLocationIcon, InfoCircleIcon, ArrowLeftIconOutline } from "../icons";
import { colors } from "configs/Theme";
import Map from "../_molecules/Map";
import { useAppSelector } from "redux/reduxHook";
import { generalTexts } from "texts/generalTexts";

interface Props {
  nextStepHandler: (value: any) => void;
  prevStepHandler: () => void;
}

const RegisterStep4 = ({ nextStepHandler, prevStepHandler }: Props) => {
  const mapInfo = useAppSelector((state) => state.mapInfo);
  return (
    <div className="w-full -mt-12">
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold pb-3">{RegisterationText?.selectAddress}</p>
        <p className="flex items-center text-xs font-medium text-grey-600 pb-3 -mr-1">
          <PlusLocationIcon width={16} height={16} stroke={colors.orange[600]} className="ml-1" />
          {RegisterationText?.addAddress}
        </p>
      </div>
      <p className="text-right text-sm font-medium pb-4">{RegisterationText?.noAddressDesc}</p>
      <Map />
      <p className="flex items-center text-sm font-medium mt-4">
        <InfoCircleIcon width={18} height={18} stroke={colors.orange[600]} className="ml-1" />
        {RegisterationText?.thisIsYourAddress}
      </p>
      <div className="flex gap-x-3 w-full mt-4">
        <Button type="text" className="bg-white flex justify-center items-center gap-x-1 text-black border-black w-full !px-2" onClick={() => prevStepHandler()} size="large">
          {generalTexts?.returnToBeforePage}
          <ArrowLeftIconOutline width={24} height={24} stroke="black" />
        </Button>

        <Button type="text" className="bg-black flex justify-center items-center gap-x-1 text-white w-full" size="large" htmlType="submit" onClick={() => nextStepHandler(mapInfo?.address)}>
          {generalTexts?.saveAddressAndContinue}
          <ArrowLeftIconOutline width={24} height={24} stroke="white" />
        </Button>
      </div>
    </div>
  );
};

export default RegisterStep4;
